import { Component, OnInit, ViewChild } from '@angular/core';
import { SwalService } from '@shared/utils/swal.service';
import { Table } from 'primeng/table';
import { AbcArticuloFormComponent } from './abc-articulo-form/abc-articulo-form.component';
import Swal from 'sweetalert2';
import { ArticuloService } from './services/articulo.service';
import { IArticulo } from './interfaces/iArticulo';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-abc-articulos',
  templateUrl: './abc-articulos.component.html'
})
export class AbcArticulosComponent implements OnInit {
  @ViewChild('dt') table: Table;
  @ViewChild(AbcArticuloFormComponent) formComponent: AbcArticuloFormComponent;

  displayDialog: boolean = false;
  selectedData: IArticulo | null = null;
  dataSource: IArticulo[] = [];
  loading: boolean = false;
  allData: number = 0;

  columns: Column[] = [
    { field: 'numero_articulo', header: 'Clave/Agregado' },
    { field: 'numero_linea', header: 'N°. Línea' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'precio', header: 'Precio' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private articuloService: ArticuloService,
    private _swalService: SwalService
  ) {}

  ngOnInit(): void {
    this.read();
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  read() {
    this.loading = true;
    this.articuloService.GetArticulos().subscribe({
      next: (res) => {
        if (res.success) {
          this.dataSource = res.data;
          this.allData = res.data.length;
        } else {
          this._swalService.error('Error al cargar los datos');
        }
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        this._swalService.error('Error al cargar los datos');
      }
    });
  }

  openCreate() {
    this.selectedData = null;
    this.displayDialog = true;
  }

  openUpdate(element: IArticulo) {
    this.selectedData = element;
    this.displayDialog = true;
  }

  onDialogClosed(refresh?: boolean) {
    this.displayDialog = false;
    if (refresh) {
      this.read();
    }
  }

  delete(model: IArticulo) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el artículo ${model.numero_articulo}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.articuloService.DeleteArticulo(model.numero_articulo).subscribe({
          next: (res) => {
            if (res.success) {
              this._swalService.success(res.data.result);
              this.read();
            } else {
              this._swalService.error('No se pudo eliminar el artículo');
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar artículo:', err);
            this._swalService.error('Error al eliminar el artículo');
            this.loading = false;
          }
        });
      }
    });
  }
} 